<template>
  <img ref="reference" :src="link" class="gallery-image bg-gray-200 z-40" />
</template>

<script>
import { fileEvidenceMixin } from "@/mixins/file-EvidenceMixin.js";

   const mimes = {
        'jpeg': 'data:image/jpeg;base64,'
    };

export default {
  name: "evidenceimage",
  mixins: [fileEvidenceMixin],
  props: {
    url: String,
    reference: String,
  },
  computed: {},
  data: function () {
    return {
      link: "/static/images/bg.jpg",
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      var vm = this
      this.getEvidenceFileFrom(this.url, mimes.jpeg)
   .then(function(data) {
           vm.link = data;

      // setTimeout(() => {
      //   GetFile.from(this.url)
      //     .then((f) => {
      //       this.link = f;
      //     })
      //     .catch((err) => {
      //       console.log(err);
           });
      // }, 1000);
    },
    checkImage(ref) {
      // console.log(this.$refs.reference.$el)
      // EXIF.getData(this.$refs.reference.$el, function () {
      //     alert(this.exifdata.Orientation);
      // });
    },
  },
};
</script>

<style scoped>
.v-lazy-image {
  filter: blur(6px);
  transition: filter 0.5s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}

.gallery-image {
  width: 100%;
  height: 100%;
  min-height: 110px !important;
  /* max-height: 180px !important; */
  object-fit: cover;
  height: 110px;
  image-orientation: from-image !important;
}
</style>
